module.exports = __webpack_public_path__ + "static/img/iconfont.81e7a13.svg";